export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'browser-tips',
    name: '浏览器技巧',
    description: '分享91网页浏览器的使用技巧和高效操作指南，帮助您充分发挥浏览器的各项功能。',
    icon: 'ri-lightbulb-line',
  },
  {
    slug: 'security-guide',
    name: '安全指南',
    description: '提供网络安全知识和91网页浏览器的安全防护功能介绍，守护您的上网安全。',
    icon: 'ri-shield-check-line',
  },
  {
    slug: 'product-updates',
    name: '产品动态',
    description: '第一时间了解91网页浏览器的最新版本更新、新功能发布和产品发展动向。',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'internet-trends',
    name: '互联网资讯',
    description: '追踪互联网行业热点动态、技术趋势和数字生活相关的精彩内容。',
    icon: 'ri-global-line',
  },
];